import React from 'react';

export const PrevIcon = () => (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="50" height="50" rx="25" fill="#757575" fillOpacity="0.25" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.3535 18.6465C28.5488 18.8417 28.5488 19.1583 28.3535 19.3536L22.7071 25L28.3535 30.6464C28.5488 30.8417 28.5488 31.1583 28.3535 31.3536C28.1583 31.5488 27.8417 31.5488 27.6464 31.3536L21.6464 25.3536C21.4512 25.1583 21.4512 24.8417 21.6464 24.6464L27.6464 18.6465C27.8417 18.4512 28.1583 18.4512 28.3535 18.6465Z"
            fill="#F5F5F5"
        />
    </svg>
);
